import { useLoaderData } from "@remix-run/react";
// import { marked } from "marked";
import invariant from "tiny-invariant";
import apiClient from "~/api/axios.server";
import { ArticleDescriptionLayout, ArticleTabs } from "~/screens";
import type { ArticleData } from "~/types";
//@ts-ignore
import type { LinksFunction, V2_MetaFunction } from "@remix-run/node";
// import { json} from  "@remix-run/node";
import articlegallerystyle from "~/screens/articles/style/article_image.css";
import config from "~/config.server";

export const links: LinksFunction = () => {
  return [{ rel: "stylesheet", href: articlegallerystyle }];
};

export const loader = async ({ request, params }: any) => {
  invariant(params.articleId, `params.articleId is required`);
  // const start = Date.now();
  // console.log("============start params.articleId", start, params.articleId);
  const cliend = apiClient();
  const { articleId } = params;

  try {
    const response = await cliend.get<ArticleData>(
      `/media/${Number(articleId)}`
    );
    // console.log("article data responze", response);
    const { data } = response;
    // const secSpent = (Date.now() - start) / 1000;
    // console.log("============response params.articleId", secSpent);
    return {
      ...data,
      baseUrl: config.BASEURL,
    };
  } catch (error: any) {
    // Handle different error scenarios with user-friendly messages
    if (error?.response?.status === 404) {
      throw new Response("Artikel nicht gefunden", {
        status: 404,
        statusText: "Der angeforderte Artikel existiert nicht.",
      });
    }

    if (error?.response?.status === 500) {
      throw new Response("Serverfehler beim Laden des Artikels", {
        status: 500,
        statusText:
          "Der Server konnte den Artikel nicht laden. Bitte versuchen Sie es später erneut.",
      });
    }

    // Generic error handling
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Ein unbekannter Fehler ist aufgetreten";

    throw new Response(errorMessage, {
      status: error?.response?.status || 500,
      statusText: "Fehler beim Laden des Artikels",
    });
  }
};
export const meta: V2_MetaFunction<typeof loader> = ({ data }: any) => {
  if (!data || !data.metaInfo) return [];
  const { metaInfo } = data;
  // console.log("dalhsdladataaaa", config);

  const metaTags: any[] = [];

  if (metaInfo.title) {
    metaTags.push({ title: metaInfo.title });
  }
  if (metaInfo.ogTitle) {
    metaTags.push({ property: "og:title", content: metaInfo.ogTitle });
  }
  if (metaInfo.canonical) {
    metaTags.push({ property: "og:url", content: metaInfo.canonical });
  }
  if (metaInfo.ogDescription) {
    metaTags.push({
      property: "og:description",
      content: metaInfo.ogDescription,
    });
  }
  if (metaInfo.ogImage) {
    metaTags.push({
      property: "og:image",
      content: `${data.baseUrl}/${metaInfo.ogImage}`,
    });
  }
  if (metaInfo.description) {
    metaTags.push({ name: "description", content: metaInfo.description });
  }

  return metaTags;
};

export default function ArticleDetail() {
  // const { articleId, articleName } = useParams();
  const data = useLoaderData<ArticleData>();
  // console.log("data", data);
  // console.log("🚀 ~ ProfessionalArticleDetail ~ data:", data);
  return (
    <div className="section-wrapper">
      <ArticleDescriptionLayout {...data} />
      {/* <div className="h-96 border-red-500">
        <Accordionlayout />
      </div> */}
      <ArticleTabs {...data} />
    </div>
  );
}
